export class MessageModel {
  message :string =  "GiftCard code has been delivered to your email"
  code :string =  "xxxxx"
}
